import {
  RatingType,
  type RatingValue,
} from "../../../domain/models/metrics";
import type {
  ExperienceFeedbackRating,
  FeedbackOverallRating,
} from "../InternalUsageTab/types";

const EMPTY_OVERALL_RATING: FeedbackOverallRating = {
  averageRating: null,
  totalFeedbackCount: 0,
};

export const computeOverallRating = (
  aggregateValues: RatingValue[] | undefined,
): FeedbackOverallRating => {
  if (!aggregateValues || aggregateValues.length === 0)
    return EMPTY_OVERALL_RATING;

  const totalCount = aggregateValues.reduce((sum, r) => sum + r.count, 0);

  if (totalCount === 0) return EMPTY_OVERALL_RATING;

  const weightedSum = aggregateValues.reduce(
    (sum, r) => sum + r.value * r.count,
    0,
  );

  return {
    averageRating: weightedSum / totalCount,
    totalFeedbackCount: totalCount,
  };
};

export const extractRatingValues = (
  values: RatingValue[] | undefined,
): Pick<
  ExperienceFeedbackRating,
  | "assessmentFeedbackCount"
  | "assessmentRating"
  | "practiceFeedbackCount"
  | "practiceRating"
> => {
  const practiceValue = values?.find(
    (v) => v.ratingType === RatingType.PRACTICE,
  );
  const assessmentValue = values?.find(
    (v) => v.ratingType === RatingType.ASSESSMENT,
  );

  return {
    practiceRating: practiceValue?.value ?? null,
    assessmentRating: assessmentValue?.value ?? null,
    practiceFeedbackCount: practiceValue?.count ?? 0,
    assessmentFeedbackCount: assessmentValue?.count ?? 0,
  };
};
